import {
  SortDescriptor,
  SortDirection,
} from "@react-types/shared/src/collections";

export function orderingParamToSortDescriptor(orderingParam: string) {
  if (!orderingParam) {
    return undefined;
  }

  const direction: SortDirection = orderingParam.startsWith("-")
    ? "descending"
    : "ascending";

  return { column: orderingParam.replace(/^-/, ""), direction };
}

export function sortDescriptorToOrderingParam(sortDescriptor: SortDescriptor) {
  const { column, direction } = sortDescriptor;

  if (!column) {
    return undefined;
  }

  return direction === "ascending" ? `${column}` : `-${column}`;
}
